var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 0c4.415 0 8 3.585 8 8s-3.585 8-8 8-8-3.585-8-8 3.585-8 8-8zm0 2c3.311 0 6 2.689 6 6s-2.689 6-6 6-6-2.689-6-6 2.689-6 6-6zm-.371 7.191a1 1 0 01-.63-.929V5a1 1 0 012 0v2.673l1.634.943a1 1 0 01-1 1.732L7.629 9.191z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDBjNC40MTUgMCA4IDMuNTg1IDggOHMtMy41ODUgOC04IDgtOC0zLjU4NS04LTggMy41ODUtOCA4LTh6bTAgMmMzLjMxMSAwIDYgMi42ODkgNiA2cy0yLjY4OSA2LTYgNi02LTIuNjg5LTYtNiAyLjY4OS02IDYtNnptLS4zNzEgNy4xOTFhMSAxIDAgMCAxLS42My0uOTI5VjVhMSAxIDAgMCAxIDIgMHYyLjY3M2wxLjYzNC45NDNhMSAxIDAgMCAxLTEgMS43MzJMNy42MjkgOS4xOTF6Ii8+Cjwvc3ZnPgo=";
export { SvgTimeOutline as ReactComponent };